import { useQuery } from '@tanstack/react-query';

import VendorsService from '~/services/VendorsService';

import { vendorQueryKeys } from './useGetVendorsByIds';

interface VendorResponse<TVendor> {
  status: number;
  result: TVendor;
}

export function useGetVendor<TVendor = App.OfferAccount>(vendorId?: string) {
  return useQuery<TVendor>({
    queryKey: vendorQueryKeys.detail(vendorId ?? ''),
    queryFn: async () => {
      if (!vendorId) {
        throw new Error('vendorId is required');
      }

      const response: VendorResponse<TVendor> = await VendorsService.getVendorById(vendorId);
      return response.result;
    },
    enabled: !!vendorId,
  });
}
